import { render, staticRenderFns } from "./HistorySentMails.vue?vue&type=template&id=687a930c"
import script from "./HistorySentMails.vue?vue&type=script&lang=js"
export * from "./HistorySentMails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports